import axios from "axios";
const MODE = "prod";

const connectionURL = 
  MODE === "prod"
    ? "https://us-central1-backend-metbrains.cloudfunctions.net/api/api"
    : MODE === "dev"
    ? "http://localhost:8000/api"
    : "";

const instance = axios.create({
  baseURL: connectionURL,
});

export const privateInstance = axios.create({
  baseURL: connectionURL,
});


instance.interceptors.response.use(handleResponse, handleResponseError);

function handleResponse(response) {
  return response;
}

async function handleResponseError(error, refresh) {
  try {
    const previousRequest = error.config;
    if (error.response?.status === 403) {
      localStorage.removeItem("MetBrains_token");
      localStorage.removeItem("MetBrains_role");
      localStorage.removeItem("MetBrains_id");
      localStorage.removeItem("MetBrains_tracker_session_id");
      localStorage.removeItem("usedOTP");
      localStorage.removeItem("x_session-token");
      if (error?.config?.url !== "/auth/logout") {
        localStorage.setItem("session_expired", true);
        window.dispatchEvent(new Event("storage"));
      }
    }
    return Promise.reject(error);
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
}

export default instance;
